// extracted by mini-css-extract-plugin
module.exports = {"NwReactCollapse":"nw-react-collapse_NwReactCollapse__zQuUG"};